import wx from 'weixin-js-sdk'

export function isWxMiniapp() {
  return window.__wxjs_environment === 'miniprogram'
}

// 微信小程序跳转
export function navigateTo(url) {
  wx.miniProgram.switchTab({
    url: url,
    success: function(res) {
      console.log(res)
    },
    fail: function(res) {
      console.log(res)
    }
  })
}

// 微信小程序跳转
export function miniappNavigateTo(url) {
  wx.miniProgram.navigateTo({
    url: url,
    success: function(res) {
        console.log(res,"微信小程序跳转success")
    },
    fail: function(res) {
      console.log(res,"微信小程序跳转fail")
    }
  })
}
